// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Proverbs",
  bookSlug: "proverbs",
  chapter: 7,
  argument: "The love of wisdom is the best preservative from being led astray by temptation.",
  verses: [
    { n: 1, text: "My son, keep my words, and lay up my precepts with thee. Son," },
    { n: 2, text: "Keep my commandments, and thou shalt live: and my law as the apple of thy eye:" },
    { n: 3, text: "Bind it upon thy fingers, write it upon the tables of thy heart." },
    { n: 4, text: "Say to wisdom: Thou art my sister: and call prudence thy friend," },
    { n: 5, text: "That she may keep thee from the woman that is not thine, and from the stranger who sweeteneth her words." },
    { n: 6, text: "For I look out of the window of my house through the lattice," },
    { n: 7, text: "And I see little ones, I behold a foolish young man," },
    { n: 8, text: "Who passeth through the street by the corner, and goeth nigh the way of her house," },
    { n: 9, text: "In the dark, when it grows late, in the darkness and obscurity of the night." },
    { n: 10, text: "And behold a woman meeteth him in harlot's attire, prepared to deceive souls: talkative and wandering," },
    { n: 11, text: "Not bearing to be quiet, not able to abide still at home," },
    { n: 12, text: "Now abroad, now in the streets, now lying in wait near the corners." },
    { n: 13, text: "And catching the young man, she kisseth him, and with an impudent face, flattereth, saying:" },
    { n: 14, text: "I vowed victims for prosperity, this day I have paid my vows." },
    { n: 15, text: "Therefore I am come out to meet thee, desirous to see thee, and I have found thee." },
    { n: 16, text: "I have woven my bed with cords, I have covered it with painted tapestry, brought from Egypt." },
    { n: 17, text: "I have perfumed my bed with myrrh, aloes, and cinnamon." },
    { n: 18, text: "Come, let us be inebriated with the breasts, and let us enjoy the desired embraces, till the day appear." },
    { n: 19, text: "For my husband is not at home, he is gone a very long journey." },
    { n: 20, text: "He took with him a bag of money: he will return home the day of the full moon." },
    { n: 21, text: "She entangled him with many words, and drew him away with the flattery of her lips." },
    { n: 22, text: "Immediately he followeth her as an ox led to be a victim, and as a lamb playing the wanton, and not knowing that he is drawn like a fool to bonds," },
    { n: 23, text: "Till the arrow pierce his liver: as if a bird should make haste to the snare, and knoweth not that his life is in danger." },
    { n: 24, text: "Now, therefore, my son, hear me, and attend to the words of my mouth." },
    { n: 25, text: "Let not thy mind be drawn away in her ways: neither be thou deceived with her paths." },
    { n: 26, text: "For she hath cast down many wounded, and the strongest have been slain by her." },
    { n: 27, text: "Her house is the way to hell, reaching even to the inner chambers of death." },
  ],
  commentary: [
    { verse: 1, notes: [
      { text: "Words. As dangerous temptations always threaten, the same instructions are frequently inculcated.", attribution: "Worthington" }
    ] },
    { verse: 5, notes: [
      { text: "Thine. But another's,", attribution: "Haydock" }
    ] },
    { verse: 19, notes: [
      { text: "Give thy heart to wisdom, that it may be guarded against impure love.", attribution: "Haydock" }
    ] },
    { verse: 6, notes: [
      { text: "Lattice. No glass was used, on account of the great heat.", attribution: "Calmet" }
    ] },
    { verse: 7, notes: [
      { text: "Ones. Not in age, but prudence.", attribution: "Menochius" }
    ] },
    { verse: 10, notes: [
      { text: "Attire. Covered with a veil, (Genesis xxxviii. 15.) though different from that of honest women. (Calmet) — The wanton are commonly the most gaudy; nullarum fere pretiosior cultus est quam quarum pudor vilis est. (St. Cyprian, de Habitu.) — Prepared, &c. Hebrew, \"guarded,\" (Calmet) or \"subtle of heart.\" (Protestants) \"who makes the hearts of youths take flight.\" (Septuagint) (Canticle of Canticles vi. 4.)", attribution: "Haydock" }
    ] },
    { verse: 11, notes: [
      { text: "Not....quiet. Is not in Hebrew. (Calmet) — \"She is loud and stubborn, her feet abide not in her house.\" (Protestants) (Haydock) — Chaste women are guarded in their speech, and keep at home.", attribution: "Menochius" }
    ] },
    { verse: 14, notes: [
      { text: "Prosperity. Or thy welfare, (Cornelius a Lapide; Tirinus) so great is my love for thee. (Menochius) — Vows. And therefore I have a feast prepared. People might carry home the greatest part of the victim to eat, if they were clean, Leviticus vii. 29.", attribution: "Calmet" }
    ] },
    { verse: 16, notes: [
      { text: "Cords. For greater ease, instead of boards, (Menochius) or the curtains are hung with precious cords from Egypt.", attribution: "Calmet" }
    ] },
    { verse: 17, notes: [
      { text: "Aloes. Of Syria, (John xix. 39.) different from ours, Numbers xxxiv. 6.", attribution: "Calmet" }
    ] },
    { verse: 18, notes: [
      { text: "Inebriated. Protestants, \"take our fill of love until the morning: let us solace ourselves with loves.\" (Haydock) — This passion is a sort of intoxication.", attribution: "Menochius" }
    ] },
    { verse: 20, notes: [
      { text: "The day. Septuagint, \"after many days.\" Hebrew, \"at the day concealed,\" or when the people will dwell under tents, (Chaldean; Calmet) or \"at the new moon,\" when it does not appear. (Piscator) — He will not return for a long time, so that we need apprehend no danger from him.", attribution: "Menochius" }
    ] },
    { verse: 22, notes: [
      { text: "Lamb. Protestants, \"fool to the correction of the stocks,\" (Haydock) or \"like a shackle (abs.) for the chastisement of a fool.\" (Mont.[Montanus?]) — Interpreters have read different words. (Calmet) — Sinners who have given way to temptations, are as inconsiderate as oxen, or birds which hasten to their own ruin.", attribution: "Worthington" }
    ] },
    { verse: 26, notes: [
      { text: "Her. Solomon gave a melancholy proof of this, as well as David, and Amnon.", attribution: "Calmet" }
    ] },
    { verse: 27, notes: [
      { text: "Death. There can be no precaution too great, chap. ii. 18.", attribution: "Calmet" }
    ] },
  ],
};

export default chapter;
